var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamIcon2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.084 19.7495V17.9162C21.0834 17.1037 20.813 16.3145 20.3152 15.6724C19.8175 15.0304 19.1206 14.5718 18.334 14.3687",
    stroke: "white",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5827 19.75V17.9167C15.5827 16.9442 15.1964 16.0116 14.5087 15.3239C13.8211 14.6363 12.8885 14.25 11.916 14.25H4.58268C3.61022 14.25 2.67759 14.6363 1.98996 15.3239C1.30232 16.0116 0.916016 16.9442 0.916016 17.9167V19.75",
    stroke: "white",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.666 3.36865C15.4547 3.57059 16.1538 4.02929 16.653 4.67244C17.1522 5.31558 17.4232 6.10658 17.4232 6.92074C17.4232 7.73489 17.1522 8.52589 16.653 9.16903C16.1538 9.81218 15.4547 10.2709 14.666 10.4728",
    stroke: "white",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25065 10.5833C10.2757 10.5833 11.9173 8.94171 11.9173 6.91667C11.9173 4.89162 10.2757 3.25 8.25065 3.25C6.22561 3.25 4.58398 4.89162 4.58398 6.91667C4.58398 8.94171 6.22561 10.5833 8.25065 10.5833Z",
    stroke: "white",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamIcon2);
export default __webpack_public_path__ + "static/media/teamIcon2.46c7e8882743d6851022768d762b79d8.svg";
export { ForwardRef as ReactComponent };